export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_05.a95f33e4.jpg";